/**
 * 通过base64获取一个Blob对象
 * @param base64str
 * @returns {*}
 */
function base64ToBlob (base64str) {
  if (!base64str) return ''
  let strArr = base64str.split(',')
  let type = strArr[0]
  let data = strArr[1]
  let text = window.atob(data)
  let buffer = new Uint8Array(text.length)
  for (let i = 0; i < text.length; i++) {
    buffer[i] = text.charCodeAt(i)
  }
  return getBlob([buffer], type)
}

/**
 * 获取blob对象的兼容性写法
 * @param buffer
 * @param format
 * @returns {*}
 */
function getBlob (buffer, format) {
  try {
    return new Blob(buffer, {type: format})
  } catch (e) {
    let bb = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MSBlobBuilder)()
    buffer.forEach(function (buf) {
      bb.append(buf)
    })
    return bb.getBlob(format)
  }
}

/**
 * 图片压缩
 * @param img
 * @returns {*}
 */
function compress (img) {
  if (!img) {
    console.error('img is null')
    return
  }
  //    用于压缩图片的canvas
  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  //    瓦片canvas
  let tCanvas = document.createElement('canvas')
  let tctx = tCanvas.getContext('2d')

  //  let initSize = img.src.length
  let width = img.width
  let height = img.height
  // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
  let ratio
  if ((ratio = width * height / 4000000) > 1) {
    ratio = Math.sqrt(ratio)
    width /= ratio
    height /= ratio
  } else {
    ratio = 1
  }
  canvas.width = width
  canvas.height = height
  //        铺底色
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  let imgList = []
  // 如果图片像素大于100万则使用瓦片绘制
  let count
  if ((count = width * height / 1000000) > 1) {
    count = ~~(Math.sqrt(count) + 1) // 计算要分成多少块瓦片
    //            计算每块瓦片的宽和高
    let nw = ~~(width / count)
    let nh = ~~(height / count)
    tCanvas.width = nw
    tCanvas.height = nh
    // let date = new Date()
    let index = 0
    for (let i = 0; i < count; i++) {
      for (let j = 0; j < count; j++) {
        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
        imgList[index++] = tCanvas.toDataURL('image/jpeg')
        tctx.clearRect(0, 0, tCanvas.width, tCanvas.height)
      }
    }
  } else {
    ctx.drawImage(img, 0, 0, width, height)
    imgList[0] = canvas.toDataURL('image/jpeg')
  }

  //
  // //进行最小压缩
  // var ndata = canvas.toDataURL('image/jpeg', 0.2);
  // var haha = document.getElementById("haha");
  // haha.innerHTML = '<p>压缩前:' + initSize + '</p><p>压缩后:' + ndata.length + ' </p><p>压缩率:'+~~(100 * (initSize - ndata.length) / initSize)+'</p>'
  // console.log('压缩前：' + initSize);
  // console.log('压缩后：' + ndata.length);
  // console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
  // tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
  return imgList
}

export {
  base64ToBlob,
  compress
}



// WEBPACK FOOTER //
// ./src/libs/utils/imgUtil.js